import { ServiceType } from '../../../../../../common/enums/serviceType';

export const possiblyEmptyServiceTypes = [ServiceType.referralSmall, ServiceType.counseling];
